import {
  prettyPhone,
  formatEIN,
  required,
  formatCurrencyOnBlur,
  phoneNumberVal,
  emailVal,
} from '../../../../helpers/utils';

export default [
  {
    label: 'Legal Name',
    name: 'legal_name',
  },
  {
    label: 'DBA',
    name: 'name',
    validate: required,
  },
  {
    label: 'Nickname',
    name: 'nickname',
  },
  {
    label: 'Previous Name',
    name: 'previous_name',
  },
  { label: 'Address', name: 'address' },
  { label: 'City', name: 'city', validate: required },
  {
    label: 'State',
    name: 'state',
    type: 'dropdown',
    component: 'select',
    validate: required,
  },
  {
    label: 'Country',
    name: 'country',
    type: 'dropdown',
    component: 'select',
    validate: required,
  },
  {
    label: 'Zip',
    name: 'zip',
    validate: required,
  },
  {
    label: 'Tax ID',
    name: 'tax_id',
    transformOnBlur: formatEIN,
  },
  {
    label: 'Phone',
    name: 'phone',
    type: 'phone',
    transformOnBlur: prettyPhone,
    validate: phoneNumberVal,
  },
  {
    label: 'Email',
    name: 'email',
    validate: emailVal,
  },
  {
    label: 'Fax',
    name: 'fax',
    type: 'phone',
    transformOnBlur: prettyPhone,
    validate: phoneNumberVal,
  },
  {
    label: 'Website',
    name: 'website',
  },
  {
    label: 'Tax Status',
    name: 'tax_status',
  },
  {
    label: 'Founding Date',
    name: 'founding_date',
    type: 'date',
  },
  {
    label: 'Expiration Date',
    name: 'expires',
    type: 'date',
  },
  {
    label: 'Current Budget',
    name: 'current_budget',
    type: 'money',
    transformOnBlur: formatCurrencyOnBlur,
  },
  {
    label: 'Mission Statement',
    name: 'mission',
    multiline: true,
    width: '100%',
  },
];
